import { takeEvery, put, call } from 'redux-saga/effects';
import {
    loginStart, loginSuccess, loginFail,
    registerStart, registerSuccess, registerFail,
    anonymousUserStart, anonymousUserSuccess, anonymousUserFail,
    logoutSuccess,
    logoutFail,
    logoutStart,
    loginWithGoogleSuccess,
    loginWithGoogleFail,
    loginWithGooleStart,
    loginWithAppleStart,
    loginWithAppleSuccess,
    loginWithAppleFail,
    deleteAccountSuccess,
    deleteAccountFail,
    deleteAccountStart,
    verifyEmailSuccess,
    verifyEmailFail,
    resendCodeSuccess,
    resendCodeFail,
    verifyEmailStart,
    resendCodeStart,
    forgotPasswordSuccess,
    forgotPasswordFail,
    resetPasswordSuccess,
    resetPasswordFail,
    forgotPasswordStart,
    resetPasswordStart,
} from '../slices/authSlice';
import { resetGuestQuota } from '../slices/promptSlice';
import { postRequest } from '../../network';
import { ANONYMOUS_USER, LOGIN, REGISTER, LOGOUT, LOGIN_WITH_GOOGLE, LOGIN_WITH_APPLE, DELETE_ACCOUNT, VERIFY_EMAIL, RESEND_CODE, FORGOT_PASSWORD, RESET_PASSWORD } from '../apis';
import { resetAllState } from 'store/resetActions';


function* loginSaga(action) {
    try {
        const response = yield call(postRequest, LOGIN, action.payload.params);
        action.payload.callback(null, response);
        if (response.verified) {
            yield put(loginSuccess(response));
            yield put(resetGuestQuota()); // Reset guest quota on login
        }
    } catch (error) {
        action.payload.callback(error.response.data.message || error.message, null);
        yield put(loginFail(error.message));
    }
}

function* loginWithGoogle(action) {
    try {
        const response = yield call(postRequest, LOGIN_WITH_GOOGLE, action.payload.params);
        action.payload.callback(null, response);
        yield put(loginWithGoogleSuccess(response));
        yield put(resetGuestQuota()); // Reset guest quota on login
    } catch (error) {
        const message = error.response?.data?.message || error.message;
        action.payload.callback(message, null);
        yield put(loginWithGoogleFail(message));
    }
}

function* loginWithApple(action) {
    try {
        const response = yield call(postRequest, LOGIN_WITH_APPLE, action.payload.params);
        action.payload.callback(null, response);
        yield put(loginWithAppleSuccess(response));
        yield put(resetGuestQuota()); // Reset guest quota on login
    } catch (error) {
        const message = error.response?.data?.message || error.message;
        action.payload.callback(message, null);
        yield put(loginWithAppleFail(message));
    }
}

function* anonymousUserSaga(action) {
    try {
        const response = yield call(postRequest, ANONYMOUS_USER, action.payload);
        yield put(anonymousUserSuccess(response));
    } catch (error) {
        yield put(anonymousUserFail(error.message));
    }
}

function* registerSaga(action) {
    try {
        const response = yield call(postRequest, REGISTER, action.payload.params);
        action.payload.callback(null, response);
        yield put(registerSuccess(response));
    } catch (error) {
        action.payload.callback(error?.response?.data?.error || error?.response?.data?.message || error.message, null);
        yield put(registerFail(error?.response?.data?.error || error?.response?.data?.message || error.message));
    }
}

function* verifyEmailSaga(action) {
    try {
        const response = yield call(postRequest, VERIFY_EMAIL, action.payload.params);
        action.payload.callback(null, response);
        yield put(verifyEmailSuccess(response));
    } catch (error) {
        console.log(error);
        action.payload.callback(error?.response?.data?.error || error?.response?.data?.message || error.message, null);
        yield put(verifyEmailFail(error?.response?.data?.error || error?.response?.data?.message || error.message));
    }
}

function* resendCodeSaga(action) {
    try {
        const response = yield call(postRequest, RESEND_CODE, action.payload.params);
        action.payload.callback(null, response);
        yield put(resendCodeSuccess(response));
    } catch (error) {
        action.payload.callback(error?.response?.data?.error || error?.response?.data?.message || error.message, null);
        yield put(resendCodeFail(error?.response?.data?.error || error?.response?.data?.message || error.message));
    }
}

function* logoutSaga(action) {
    try {
        const response = yield call(postRequest, LOGOUT, action.payload.params);
        action.payload.callback(null, response);
        yield put(resetAllState());
        yield put(logoutSuccess(response));
    } catch (error) {
        action.payload.callback(error.message, null);
        yield put(logoutFail(error.message));
    }
}

function* deleteAccount(action) {
    try {
        const response = yield call(postRequest, DELETE_ACCOUNT, action.payload.params);
        yield put(deleteAccountSuccess(response));
        action.payload.callback(null, response);
    } catch (error) {
        const message = error.response?.data?.message || error.message;
        yield put(deleteAccountFail(message));
        action.payload.callback(message, null);
    }
}


function* forgotPasswordSaga(action) {
    try {
        const response = yield call(postRequest, FORGOT_PASSWORD, action.payload.params);
        yield put(forgotPasswordSuccess(response));
        action.payload.callback?.(null, response);
    } catch (error) {
        const message = error.response?.data?.message || error.message;
        yield put(forgotPasswordFail(message));
        action.payload.callback?.(message, null);
    }
}


function* resetPasswordSaga(action) {
    try {
        const response = yield call(postRequest, RESET_PASSWORD, action.payload.params);
        yield put(resetPasswordSuccess(response));
        action.payload.callback?.(null, response);
    } catch (error) {
        const message = error.response?.data?.message || error.message;
        yield put(resetPasswordFail(message));
        action.payload.callback?.(message, null);
    }
}

export function* watchAuth() {
    yield takeEvery(loginStart.type, loginSaga);
    yield takeEvery(anonymousUserStart.type, anonymousUserSaga);
    yield takeEvery(registerStart.type, registerSaga);
    yield takeEvery(logoutStart.type, logoutSaga);
    yield takeEvery(loginWithGooleStart.type, loginWithGoogle);
    yield takeEvery(loginWithAppleStart.type, loginWithApple);
    yield takeEvery(deleteAccountStart.type, deleteAccount);
    yield takeEvery(verifyEmailStart.type, verifyEmailSaga);
    yield takeEvery(resendCodeStart.type, resendCodeSaga);
    yield takeEvery(forgotPasswordStart.type, forgotPasswordSaga);
    yield takeEvery(resetPasswordStart.type, resetPasswordSaga);
}
